import { trigger, state, style, transition, animate } from '@angular/animations';

export const rotateAnimation = trigger('rotateAnimation', [
  state('true', style({ transform: 'rotate(180deg)' })),
  state('false', style({ transform: 'rotate(0)' })),
  transition('true <=> false', animate('300ms ease-in-out')),
]);

export const expandCollapse = trigger('expandCollapse', [
  transition(':enter', [
    style({ opacity: 0, transform: 'translateY(-8px)' }),
    animate('250ms ease-out', style({ opacity: 1, transform: 'translateY(0)' })),
  ]),
  transition(':leave', [
    animate('200ms ease-in', style({ opacity: 0, transform: 'translateY(-8px)' })),
  ]),
]);
